import { ApplicationMetricData } from "api/applications";
import { Money } from "shared/types";

export type DebtItem = {
  id: string;
  name: string;
  description: string;
  amount: Money;
  included: boolean;
  is_potential_duplicate: boolean;
};

export type ApplicantDebtGroup = {
  applicant_id: number;
  applicant_name: string;
  applicant_role: string;
  is_primary_applicant: boolean;
  total_monthly_debt_cents: number;
  debts: DebtItem[];
};

export type ApplicationRentBreakdown = {
  listed_rent: Money;
  pet_rent: Money;
  housing_assistance: Money;
  total: Money;
};

export type GroupDebtDetails = {
  application_rent: ApplicationRentBreakdown;
  applicant_debts: ApplicantDebtGroup[];
  total_emp_cents: number;
  net_income: number;
  gross_income: number;
  debt_to_net_income: number;
  debt_to_gross_income: number;
};

export interface ConfigureMetricsDrawerProps {
  opened: boolean;
  onClose: () => void;
  existingMetric?: ApplicationMetricData | null;
}

export enum MetricBreakdownColumn {
  User = "user",
  CreditScore = "credit_score",
  NetIncome = "net_income",
  GrossIncome = "gross_income",
  MonthlyDebt = "monthly_debt",
  SelfAttestedGrossIncome = "self_attested_gross_income",
  VerifiedGrossIncome = "verified_gross_income",
  VerifiedNetIncome = "verified_net_income",
  VerifiedBadge = "verified_badge",
  SelfReportedBadge = "self_reported_badge",
  ViewCreditReport = "view_credit_report",
  ViewApplication = "view_application"
}

export interface MetricModalData {
  title: string;
  warningText?: string;
  detailText: string;
  columns: MetricBreakdownColumn[];
}
